import type {MetlApiBase} from "../../../metl-api/MetlApiBase.ts";
import {ApiAtom} from "../../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {useAtomValue} from "jotai";
import {type CustomerAnalysisOptions, CustomerAnalysisOptionsAtom} from "../../1-options/CustomerAnalysisOptions.ts";
import {type ActionProgress, type StartAction, useScanActions} from "../../../analysis-process/3-perform-scan/util/ctx/useScanActions.tsx";
import {type LogError, type LogMessage, useScanMessages} from "../../../analysis-process/3-perform-scan/util/ctx/useScanMessages.tsx";

export interface CustomerScanContext {
    options: CustomerAnalysisOptions
    api: MetlApiBase
    log: (message: string) => void
    logError: LogError
    startAction: StartAction
    scanErrors: string[]

    dbEnvironment: string
    metlVersion: string
}

export interface ScanDisplayInfo {
    loggedMessages: LogMessage[]
    activeActions: ActionProgress[]
}

export function useCustomerScanContext(): [CustomerScanContext, ScanDisplayInfo] {
    const options = useAtomValue(CustomerAnalysisOptionsAtom)
    const api = useAtomValue(ApiAtom)!
    const [loggedMessages, log, logError, errors] = useScanMessages(options)
    const [activeActions, startAction] = useScanActions()
    
    return [
        {
            options,
            api,
            log,
            logError,
            startAction,
            scanErrors: errors,
            dbEnvironment: "",
            metlVersion: ""
        },
        {
            loggedMessages,
            activeActions
        }
    ]
}
